<template>
  <expandable-material-card
    :title="$t('components.portal.theme.app_footer.colors')"
    :color="$vuetify.theme.themes.light.secondary"
    icon="format_color_fill"
    style="margin-top: 30px"
    v-if="innerItem !== null && innerItem !== undefined"
  >
    <v-card-text>
      <v-form v-model="valid">
        <!-- {{ $t("components.portal.theme_settings.theme_colors") }} -->
        <v-layout row wrap>
          <v-col cols="12" sm="6" md="4" lg="3">
            <color-selector
              :value.sync="innerItem.Colors.Background"
              :rules="[$rules.required]"
              class="required"
              :label="$t('components.portal.theme.left_drawer.background')"
              :hexColorsOnly="true"
            />
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <color-selector
              :value.sync="innerItem.Colors.Text"
              :rules="[$rules.required]"
              class="required"
              :label="$t('components.portal.theme.left_drawer.text')"
              :hexColorsOnly="true"
            />
          </v-col>
        </v-layout>
      </v-form>
    </v-card-text>
  </expandable-material-card>
</template>
<script>
import ColorSelector from "../ColorSelector.vue";
import ExpandableMaterialCard from "@/components/Portal/ExpandableMaterialCard.vue";
export default {
  props: ["theme"],
  components: {
    ExpandableMaterialCard,
    ColorSelector,
  },
  data() {
    return {
      valid: false,
      innerItem: null,
    };
  },
  watch: {
    theme: {
      handler(v) {
        if (v !== null && v !== undefined) {
          this.innerItem = JSON.parse(JSON.stringify(v.AppFooter.Light));
        }
      },
    },
    innerItem: {
      handler(v) {
        if (v !== null && v !== undefined) {
          this.$emit("update", v);
        }
      },
      deep: true
    },
    valid: {
      handler(v) {
        this.$emit("valid", v);
      },
    },
  },
  mounted() {
    if (this.theme !== null && this.theme !== undefined) {
      this.innerItem = JSON.parse(
        JSON.stringify(this.theme.AppFooter.Light)
      );
    }
  },
};
</script>
